export default __webpack_public_path__ + "static/media/artist_palette.8eb89355.png";